
const shadows = {
  shadow1:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  shadow2:'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
  shadow3:'0px 8px 20px rgba(35, 35, 35, 0.1)'
};

export default shadows;
